<div class="col-12">
  <div class="row">
    <h4 class="my-3"><b>Formularios creados</b></h4>
    <div class="col-12 px-0 mb-4">
      <button [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" type="button" class="btn label label-info label-rounded" title="Editar" (click)="changeForm(null)" ><b>+ Crear nuevo</b></button>&nbsp;
    </div>
    <div class="col-12 col-md-6 px-0">
      <input [(ngModel)]="formFilter" class="form-control custom-input" type="text" id="example-date-input" placeholder="Buscar">
      <span class="help-block"><small>Filtrar por nombre de formulario</small></span>
    </div>
    <table class="table tests-table" >
      <thead>
          <tr>
              <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="" >Formulario</th>
              <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="text-center" >Puntaje de aprobación</th>
              <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="text-center" >Es excluyente</th>
              <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="w-130 text-center">Acciones</th>
          </tr>
      </thead>
      
      <tbody *ngIf="forms.length > 0">
          <tr *ngFor="let form of forms | formFilter: formFilter; index as i ">
              <td class="footable-visible">{{form.title}}</td>
              <td class="footable-visible text-center">{{form.aprovationScore}}</td>
              <td class="footable-visible text-center">{{form.exclude ? 'SI' : 'NO'}}</td>
              <td class="footable-visible footable-last-column text-center px-1 w-150">
                <button [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" type="button" class="btn label label-info label-rounded" title="Editar" (click)="changeForm(form)" ><b>Editar</b></button>&nbsp;
                <button type="button" class="btn label label-danger label-rounded" title="Editar" (click)="selectedForm = form; deleteForm()" ><b>Eliminar</b></button>&nbsp;
              </td>
          </tr>
      </tbody>
      
    </table>

  </div>

  <div id="formSection"></div>

  <div *ngIf="isVisible" class="row justify-content-between">

    <div class="col-12 mt-3">
      <div class="row">
        <h5 class="my-3"><b>Configuración</b></h5>
      </div>
      <div class="row">
        <div class="col-12 mx-0 px-0 mb-3">
          <div class="demo-switch-title align-left"><small>Incluyente/Excluyente</small></div>
          <div class="switch align-left">
            <label>
              <input [(ngModel)]="exclude" type="checkbox"><span
                class="lever switch-col-indigo"></span>
            </label>
            <label class="mytooltip"><b class="text-info">?</b><span class="tooltip-content4"><b>Incluyente:</b> Si el evaluado no cumple con el requisito de aprobación, continúa con las pruebas asignadas. (Aquí no aprovechará el propósito del formulario, solo recabará información adicional).<br><b>Excluyente:</b> Si el evaluado no cumple el requisito de aprobación, es eliminado del proceso de selección y usted no consume créditos en esas pruebas.</span></label>
          </div>
        </div>

        <div class="form-group">
          <label>
            <small>Puntaje para aprobar <b>(Quienes no alcancen o superen el puntaje no continuarán con las pruebas asignadas -en modo excluyente-)</b></small>
            <input autocomplete="off" [(ngModel)]="aprovationScore" type="number"  class="form-control" placeholder="Puntaje para aprobar">
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-12 px-0">
          <div class="form-group">
            <label>
              Mensaje de bienvenida (puede personalizarlo)
              <textarea class="form-control" rows="5" [(ngModel)]="successMessage" placeholder="Mensaje de bienvenida"></textarea>
            </label>
          </div>
        </div>
        <div class="col-12 px-0">
          <div class="form-group">
            <label>
              Mensaje de finalización (puede personalizarlo)
              <textarea class="form-control" rows="5" [(ngModel)]="failMessage" placeholder="Mensaje de finalización"></textarea>
            </label>
          </div>
        </div>
      </div>
    </div>

      <!-- <button (click)="creatingFieldType = 'text'; editingIndex = -1" class="btn btn-info btn-sm waves-effect btn-rounded">Pregunta de texto</button>
      <button (click)="creatingFieldType = 'number'; editingIndex = -1" class="btn btn-info btn-sm waves-effect btn-rounded">Pregunta numérica</button>
      <button (click)="creatingFieldType = 'radio'; editingIndex = -1" class="btn btn-info btn-sm waves-effect btn-rounded">Pregunta de selección</button>
      <button (click)="creatingFieldType = 'multiple'; editingIndex = -1" class="btn btn-info btn-sm waves-effect btn-rounded">Pregunta de seleccion múltiple</button> -->

      <div class="col-12 px-0 mt-2">
        <h5 class="modal-title mb-3" id="exampleModalLabel"><b>Agregar preguntas</b></h5>

        <div class="form-group">
          <label>
            <small>Tipo de pregunta</small>
            <select [(ngModel)]="creatingFieldType" class="form-control">
              <option value="text" >Texto</option>
              <option value="number" >Numérica</option>
              <option value="radio" >Selección simple</option>
              <option value="multiple" >Selección múltiple</option>
            </select>
          </label>
        </div>

        <h5 *ngIf="creatingFieldType=='text'"><small><b>Agregando pregunta de texto</b></small></h5>
        <h5 *ngIf="creatingFieldType=='number'"><small><b>Agregando pregunta numérica</b></small></h5>
        <h5 *ngIf="creatingFieldType=='radio'"><small><b>Agregando pregunta de selección</b></small></h5>
        <h5 *ngIf="creatingFieldType=='multiple'"><small><b>Agregando pregunta de selección multiple</b></small></h5>

      </div>

      
      <div *ngIf="creatingFieldType=='text'" class="col-md-12 mt-3 px-0">
          <div class="form-group">
              <input autocomplete="off" [(ngModel)]="title" type="text"  class="form-control" placeholder="Pregunta">
          </div>
          <button (click)="createField('text')" class="btn btn-success btn-sm btn-rounded waves-effect">{{editingIndex == -1 ? 'Agregar':'Actualizar'}}</button>
      </div>

      <div *ngIf="creatingFieldType=='number'" class="col-md-12 mt-3 px-0">
          <div class="form-group">
              <small>Pregunta</small>
              <input autocomplete="off" [(ngModel)]="title" type="text"  class="form-control" placeholder="Pregunta">
          </div>
          <div class="form-group">
            <small>Valor correcto</small>
            <input autocomplete="off" [(ngModel)]="correctValue" type="number"  class="form-control" placeholder="Valor correcto">
          </div>
          <div class="form-group">
            <small>Puntaje</small>
            <input autocomplete="off" [(ngModel)]="value" type="number"  class="form-control" placeholder="Puntaje">
          </div>
          <button (click)="createField('number')" class="btn btn-success btn-rounded btn-sm waves-effect">{{editingIndex == -1 ? 'Agregar':'Actualizar'}}</button>
      </div>

      <div *ngIf="creatingFieldType=='radio'" class="col-md-12 mt-3 px-0">
          <div class="form-group">
              <input autocomplete="off" [(ngModel)]="title" type="text"  class="form-control" placeholder="Pregunta">
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                  <input autocomplete="off" [(ngModel)]="option.text" type="text"  class="form-control" placeholder="Agregar opción">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <input autocomplete="off" [(ngModel)]="option.value" type="number"  class="form-control" placeholder="Puntaje">
            </div>
            </div>
          </div>
          <ul>
              <li *ngFor="let opc of radioField; index as o">
                  {{opc.text}} - {{opc.value}} puntos 
                  <i class="fa fa-pencil pointer" (click)="editOption(o)"></i>
                  &nbsp;
                  <i class="fa fa-times pointer" (click)="deleteOption(o, 'radio')"></i>
              </li>
          </ul>
          <button (click)="addRadio()" class="btn btn-info waves-effect btn-sm btn-rounded mr-2">{{editingOptionIndex == -1 ? 'Agregar opción' : 'Actualizar opción'}}</button>
          <button (click)="createField('radio')" class="btn btn-info waves-effect btn-sm btn-rounded">{{editingIndex == -1 ? 'Agregar pregunta':'Actualizar pregunta'}}</button>
      </div>


      <div *ngIf="creatingFieldType=='multiple'" class="col-md-12 mt-3 px-0">
        <div class="form-group">
            <input autocomplete="off" [(ngModel)]="title" type="text"  class="form-control" placeholder="Pregunta">
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
                <input autocomplete="off" [(ngModel)]="option.text" type="text"  class="form-control" placeholder="Agregar opción">
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <input autocomplete="off" [(ngModel)]="option.value" type="number"  class="form-control" placeholder="Puntaje">
            </div>
          </div>
        </div>
        <ul>
            <li *ngFor="let opc of multipleField; index as o">
              {{opc.text}} - {{opc.value}} puntos 
              <i class="fa fa-pencil pointer" (click)="editOption(o)"></i>
              &nbsp;
              <i class="fa fa-times pointer" (click)="deleteOption(o, 'multiple')"></i>
            </li>
        </ul>
        <button (click)="addMultiple()" class="btn btn-info waves-effect btn-sm btn-rounded mr-2">{{editingOptionIndex == -1 ? 'Agregar opción' : 'Actualizar opción'}}</button>
        <button (click)="createField('multiple')" class="btn btn-info waves-effect btn-sm btn-rounded">{{editingIndex == -1 ? 'Agregar pregunta':'Actualizar pregunta'}}</button>
      </div>

      <div class="col-12 mt-3">
        <div class="row">
          <h5 class="mt-3"><b>Preguntas agregadas</b></h5>
        </div>
      </div>

      <div *ngIf="formModel.length > 0" class="table">
        <table>
          <tr>
            <th><b>Tipo</b></th>
            <th><b>Pregunta</b></th>
            <th><b>Acciones</b></th>
          </tr>
          <ng-container *ngFor="let field of formModel; index as i">
            <tr>
              <th>
                <div *ngIf="field.type=='text'">
                  Texto
                </div>
                <div *ngIf="field.type=='number'">
                  Numérico
                </div>
                <div *ngIf="field.type=='radio'">
                  Opción
                </div>
                <div *ngIf="field.type=='multiple'">
                  Múltiple
                </div>
              </th>
              <th>
                {{field.text}}
              </th>
              <th>
                <i class="fa fa-times pointer" (click)="deleteField(i)"></i> &nbsp;
                <i class="fa fa-pencil pointer" (click)="editField(i)"></i>
              </th>
            </tr>

            <tr *ngIf="field.type == 'number'">
              <td></td>
              <td>
                <b>Valor correcto:</b> {{field.correctValue}}<br>
                <b>Puntaje:</b> {{field.value}}
              </td>
              <td></td>
            </tr>

            <tr *ngIf="field.type == 'radio' || field.type == 'multiple'">
              <td></td>
              <td>
                <ul>
                  <li *ngFor="let opc of field.data">
                    <b>{{opc.text}}</b> - {{opc.value}} puntos
                  </li>
                </ul>
              </td>
              <td></td>
            
          </ng-container>
        </table>
      </div>
          <!-- <ul class="mt-3">
              <li *ngFor="let field of formModel; index as i">
                  <div *ngIf="field.type=='text'">
                      <p>Campo de texto: {{field.text}}&nbsp; <span style="cursor: pointer;" (click)="deleteField(i)" class="text-danger">X</span></p>
                  </div>
                  <div *ngIf="field.type=='number'">
                      <p>Campo numérico: {{field.text}}&nbsp; <span style="cursor: pointer;" (click)="deleteField(i)" class="text-danger">X</span></p>
                      <p></p>
                  </div>
                  <div *ngIf="field.type=='radio' || field.type=='multiple'">
                      <p>{{field.type == 'radio' ? 'Campo de opción seleccionable' : 'Campo de selecciones múltiples'}}</p>
                      <p>{{field.text}}&nbsp; <span style="cursor: pointer;" (click)="deleteField(i)" class="text-danger">X</span></p>
                      <ul>
                          <li *ngFor="let opc of field.data"><b>{{opc}}</b></li>
                      </ul>
                  </div>
              </li>
          </ul> -->



  </div>

  <div *ngIf="isVisible" class="row">
    <!-- <div class="col-12 px-0">
      <h5 class="my-3"><b>Formularios guardados</b></h5>
    </div> -->
    <div class="col-12 px-0">
      <!-- <div class="form-group mb-1">
        <label>
          Seleccionar
          <select (ngModelChange)="changeForm($event)" [(ngModel)]="selectedForm" class="form-control">
              <option [ngValue]="{data:[], title:''}">Nuevo</option>
              <option *ngFor="let form of forms" [ngValue]="form">{{form.title}}</option>
          </select>
        </label>
      </div> -->
      <div class="form-group">
        <label>
          <small>Nombre del formulario</small>
          <input autocomplete="off" [(ngModel)]="formTitle" type="text"  class="form-control" placeholder="Nombre del formulario">
        </label>
      </div>
    </div>
    <div class="col-12 px-0 mt-3">
      <button *ngIf="selectedForm" type="button" class="btn btn-danger btn-sm btn-rounded" (click)="deleteForm()">Borrar formulario</button>
      <button type="button" class="btn btn-success btn-sm btn-rounded mx-1" (click)="saveForm()">Guardar formulario</button>
    </div>
  </div>
</div>